import Breadcrumb from '../Component/Breadcrumb'
const Uniform = () => {
    return (
        <>
            <Breadcrumb breadtitle="School Uniform" breadmid="About" breadend="School Uniform
" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className='maintitle mt-4'>Summer Uniform for Classes</h2>
                            <img src='https://webapi.entab.info/api/image/CSFL/public/images/uniform.jpg' className='img-fluid' alt="Cannosa School, Lucknow" />
                            <h2 className='maintitle mt-4'>Winter Uniform for Classes</h2>
                           
          
          <h5><span>Class Nursery &amp; K.G. (for Girls)</span></h5>
          <p>Red checked skirt with cream colour top, Red Legees, Black shoes, Red sweater and Red Blazer, Red
            Cap/Scarf.</p>
          <h5><span>Class Nursery &amp; K.G. (for Boys)</span></h5>
          <p>Red checked Full-pants, Cream colour shirt, Red socks, Black shoes, Red Sweater and Red Blazer, Red Cap.
          </p>
          <h5><span>Class I - V (for Girls)</span></h5>
          <p>Sky Blue tunic, white long sleeved shirt, Navy blue sweater with two sky blue stripes border on neck and
            sleeves, and Navy blue blazer in addition to the above, blue scarf/cap and black shoes.</p>
          <h5><span>Class I - VI (for Boys)</span></h5>
          <p>Sky Blue pant, white long sleeved shirt, Navy blue sweater with two sky blue stripes border on neck and
            sleeves, and Navy blue coat in addition to the above, Navy blue Woollen cap and black shoes.</p>
          <h5><span>Class VI - VIII (for Girls)</span></h5>
          <p>Sky Blue Skirt, white long sleeved shirt, Navy blue sweater with two sky blue stripes boarder on neck and
            sleeves, and Navy Blue, Blazer in addition to the above, blue scarf/cap and black shoes.</p>
          <h5><span>Class IX to XII</span></h5>
          <p>Navy Blue sweater with two sky blue stripes border on neck and sleeves, and Navy Blue Blazer in addition to
            the above, blue scarf/cap and black shoes.</p>
            <h2 className='maintitle mt-4'>P.T. Uniform on Saturdays</h2>
          <h5><span>For Girls:</span></h5>
          <p>White Tunic for classes I to V; divided skirt and House T-shirt for classes VI to VIII; White salwar and
            Top with House Dupatta for classes IX to XII.
            White socks with three blue stripes and white canvas shoes.</p>
          <h5><span>For Boys:</span></h5>
          <p>White Pants, White socks with three blue stripes and white canvas shoes, for classes I to V and House
            T-shirt for Class VI to VIII</p>
          <p><span>The shade of the uniform should be the same as approved by the School Authorities.</span></p>
         
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
export default Uniform